import { render, staticRenderFns } from "./performanceData.vue?vue&type=template&id=11b08c62"
import script from "./performanceData.vue?vue&type=script&lang=js"
export * from "./performanceData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports